<div [formGroup]="form" class="flex flex-col gap-6">
  <div *ngIf="!viewDisable" class="flex flex-col md:flex-row gap-6">
    <div class="flex-1 flex flex-col gap-6">
      <!-- Assignee Select -->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Choose Assignee</mat-label>
        <mat-select formControlName="assigneeId">
          <mat-option
            *ngFor="let assignee of assignees(); trackBy: trackByAssignee"
            [value]="assignee.id"
          >
            {{ assignee.firstName }} {{ assignee.lastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Status Select -->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Choose Status</mat-label>
        <mat-select formControlName="status">
          <mat-option
            *ngFor="let status of orderStatuses(); trackBy: trackByStatus"
            [value]="status.key"
          >
            {{ status.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="flex-1 flex flex-col gap-2">
      <!-- Client Autocomplete -->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Choose Client</mat-label>
        <input
          type="text"
          matInput
          [matAutocomplete]="auto"
          formControlName="client"
          #clientInput
          (input)="onClientInput(clientInput.value)"
          autocomplete="off"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayClient"
          (optionSelected)="onClientSelected($event)"
        >
          <mat-option
            *ngFor="let client of filteredClients; trackBy: trackByClient"
            [value]="client"
          >
            {{ client.firstName }} {{ client.lastName }}, {{ client.customerCode1 }},
            {{ client.company }}, {{ client.address1State }}, {{ client.address1Street }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <!-- Client Details -->
      <div *ngIf="selectedClient" class="bg-white shadow p-3 rounded border text-xs">
        <div class="font-semibold">Client Company: {{ selectedClient.company }}</div>
        <div>Customer: {{ selectedClient.customerCode1 }}</div>
        <div>Email: {{ selectedClient.email }}</div>
        <div>Phone: {{ selectedClient.primaryPhone }}</div>
      </div>
    </div>
  </div>
  <!-- Job Description -->
  <mat-form-field appearance="fill" class="w-full mt-6">
    <mat-label>Job Description</mat-label>
    <textarea matInput formControlName="description" rows="4"></textarea>
  </mat-form-field>

  <!-- Notes to Client -->
  <mat-form-field appearance="fill" class="w-full">
    <mat-label>Notes to Client</mat-label>
    <textarea matInput formControlName="clientNotes" rows="4"></textarea>
  </mat-form-field>
</div>

<div class="flex justify-end gap-4 mt-6">
  <button mat-flat-button type="button" (click)="onCancel()">Cancel</button>
  <button
    mat-flat-button
    *ngIf="!viewDisable"
    color="primary"
    type="button"
    (click)="onSaveChanges()"
    [disabled]="isSaving || form.invalid"
    class="relative flex items-center justify-center min-w-[140px]"
  >
    <ng-container *ngIf="isSaving; else saveText">
      <mat-progress-spinner
        diameter="20"
        mode="indeterminate"
        color="accent"
        class="!inline-block align-middle"
        [strokeWidth]="3"
      ></mat-progress-spinner>
      <span>Saving</span>
    </ng-container>
    <ng-template #saveText>Save Changes</ng-template>
  </button>
</div>
